import { theme } from '@prophecy/theme';
import styled from 'styled-components';
import { AutoComplete } from '../Select/AutoComplete';
import { SELECT_ARROW_CLASS, SELECT_ROOT_CLASS, SELECT_SEARCH_INPUT_CLASS, SELECT_SELECTION_SEARCH_CLASS, SELECT_SELECTOR_CLASS } from '../Select/tokens';
export const StyledMentionAutoComplete = styled(AutoComplete) `
  .${SELECT_ROOT_CLASS} {
    all: unset;
  }

  .${SELECT_SELECTOR_CLASS} {
    padding: 0;
    height: auto;
  }

  .${SELECT_ARROW_CLASS} {
    display: none;
  }

  .${SELECT_SELECTION_SEARCH_CLASS} {
    &:after {
      content: attr(data-value);
      opacity: 0;
    }
  }

  .${SELECT_SEARCH_INPUT_CLASS} {
    width: 100%;
    color: ${theme.colors.brand600};
  }
`;
export const StyledMention = styled.span `
  color: ${theme.colors.brand600};
`;
